import React from 'react';
import './MiningProducts.css';
import { useLanguage } from '../../../context/LanguageContext';
import { getTranslation } from '../../../i18n/translations';

const MiningProducts = () => {
  const { language } = useLanguage();
  const products = [
    {
      title: 'Rent ASICs Mining Contracts',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
          <g clipPath="url(#clip0_6330_23156)">
            <path
              d="M0.54 7.7C0.54 6.43097 0.54042 5.51168 0.599515 4.78838C0.658096 4.07139 0.771631 3.59469 0.971614 3.2022C1.35127 2.45708 1.95708 1.85127 2.7022 1.47161C3.09469 1.27163 3.57139 1.1581 4.28838 1.09952C5.01168 1.04042 5.93097 1.04 7.2 1.04H16.8C18.069 1.04 18.9883 1.04042 19.7116 1.09952C20.4286 1.1581 20.9053 1.27163 21.2978 1.47161C22.0429 1.85127 22.6487 2.45708 23.0284 3.2022C23.2284 3.59469 23.3419 4.07139 23.4005 4.78838C23.4596 5.51168 23.46 6.43097 23.46 7.7V17.3C23.46 18.569 23.4596 19.4883 23.4005 20.2116C23.3419 20.9286 23.2284 21.4053 23.0284 21.7978C22.6487 22.5429 22.0429 23.1487 21.2978 23.5284C20.9053 23.7284 20.4286 23.8419 19.7116 23.9005C18.9883 23.9596 18.069 23.96 16.8 23.96H7.2C5.93097 23.96 5.01168 23.9596 4.28838 23.9005C3.57139 23.8419 3.09469 23.7284 2.7022 23.5284C1.95708 23.1487 1.35127 22.5429 0.971614 21.7978C0.771631 21.4053 0.658096 20.9286 0.599515 20.2116C0.54042 19.4883 0.54 18.569 0.54 17.3V7.7Z"
              stroke="#1570EF"
              strokeWidth="1.08"
              strokeLinecap="round"
              strokeLinejoin="round" 
            />
            <path
              d="M8.39075 7.63168L8.69861 7.94634L9.06212 7.69806L9.65508 7.29307C9.65515 7.29301 9.65523 7.29296 9.6553 7.29291C11.2294 6.22014 13.1691 5.5148 15.5185 5.1753C15.7982 5.13652 15.9865 5.14577 16.122 5.17976C16.2476 5.21126 16.351 5.26955 16.4555 5.37443C16.6667 5.58626 16.7258 5.84924 16.6446 6.10511C16.6122 6.19937 16.589 6.24689 16.5669 6.28075C16.5468 6.31157 16.5154 6.34966 16.4461 6.40434C16.285 6.53145 15.9979 6.69103 15.3905 6.9989C13.5346 7.93939 12.6393 8.51641 11.6914 9.40016C11.6911 9.40042 11.6908 9.40068 11.6906 9.40095L11.2881 9.77309L10.887 10.1441L11.2737 10.5301L15.0355 14.2848C16.5767 15.8277 17.5162 16.7765 18.0812 17.3676C18.3645 17.664 18.5468 17.8634 18.6618 17.9993C18.7514 18.1052 18.7806 18.1507 18.7856 18.1572C18.973 18.6957 18.4118 19.2646 17.844 19.0552C17.8386 19.0509 17.832 19.0457 17.8243 19.0394C17.7806 19.0039 17.7169 18.9488 17.6302 18.8704C17.4577 18.7144 17.2121 18.4827 16.8874 18.1692C16.2389 17.5431 15.2883 16.6037 14.004 15.3217C12.9742 14.2918 12.0307 13.358 11.3401 12.6827C10.9951 12.3453 10.7119 12.0711 10.5121 11.8814C10.4128 11.787 10.3314 11.711 10.2724 11.6577C10.2438 11.632 10.2151 11.6067 10.1901 11.5863C10.1792 11.5774 10.1588 11.561 10.1346 11.5447C10.1245 11.5379 10.0972 11.5196 10.0603 11.5022C10.0428 11.4939 10.0049 11.4769 9.9541 11.465C9.91815 11.4565 9.7884 11.4281 9.63735 11.4888L9.63735 11.4888C9.54472 11.526 9.48022 11.5825 9.46796 11.5932C9.46732 11.5938 9.46683 11.5942 9.46648 11.5945C9.43916 11.618 9.4139 11.6428 9.39345 11.6638C9.35151 11.7067 9.30368 11.7602 9.2543 11.8176C9.15422 11.9338 9.02826 12.0886 8.89341 12.2598C8.62354 12.6022 8.30455 13.0271 8.06365 13.3732L8.06248 13.3749C7.47906 14.2203 7.01913 15.0072 6.51781 15.9937L6.51684 15.9956C6.16316 16.6986 6.10358 16.7434 6.01284 16.8059L6.01282 16.8058L6.00731 16.8097C5.62693 17.0786 5.09691 16.9314 4.90713 16.4783L4.90698 16.4779C4.88608 16.4282 4.85307 16.251 4.89478 15.8342C4.93413 15.4409 5.03102 14.907 5.19331 14.2026L5.19349 14.2018C5.53344 12.7159 6.22197 11.1113 7.00397 9.95254C7.0041 9.95235 7.00423 9.95216 7.00436 9.95196L7.40761 9.35782L7.6533 8.99583L7.34155 8.68889L7.0013 8.35389C7.0012 8.35379 7.0011 8.35369 7.001 8.35359C6.63824 7.99511 6.56394 7.77322 6.56394 7.57483C6.56394 7.33536 6.62128 7.20152 6.78443 7.04468C6.8849 6.95148 6.9509 6.91241 7.00508 6.89111C7.05999 6.86953 7.13819 6.8523 7.28253 6.8523C7.47846 6.8523 7.69893 6.92591 8.05653 7.29008C8.05662 7.29017 8.05672 7.29027 8.05681 7.29036L8.39075 7.63168Z"
              stroke="#1570EF"
              strokeWidth="1.05"
            />
          </g>
          <defs>
            <clipPath id="clip0_6330_23156">
              <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      ),
      price: '$99',
      priceBg: '#1570EF',
      detailsBg: '#E5F1FF',
      details: [ 
        'Rent hashpower and get daily rewards',
        'Now you can start mining and earn BTC from as low as $99!',
        '24 hours pass from purchase to work',
      ],
      link: '/mining-store/buy-asics',
    },
    {
      title: 'Buy Purchase ASICs With Hosting',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5466_33167)">
            <rect
              x="0.43125"
              y="0.525"
              width="22.95"
              height="22.95"
              rx="4.275"
              stroke="#F7B27A"
              strokeWidth="1.05"
            />
            <path
              d="M12.675 7.33333C12.675 8.06971 11.0129 8.66667 8.9625 8.66667C6.91214 8.66667 5.25 8.06971 5.25 7.33333M12.675 7.33333C12.675 6.59695 11.0129 6 8.9625 6C6.91214 6 5.25 6.59695 5.25 7.33333M12.675 7.33333V8.33333M5.25 7.33333V15.3333C5.25 16.0697 6.91214 16.6667 8.9625 16.6667M8.9625 11.3333C8.84873 11.3333 8.73616 11.3315 8.625 11.3279C6.73281 11.2667 5.25 10.6955 5.25 10M8.9625 14C6.91214 14 5.25 13.403 5.25 12.6667M18.75 11.6667C18.75 12.403 17.0879 13 15.0375 13C12.9871 13 11.325 12.403 11.325 11.6667M18.75 11.6667C18.75 10.9303 17.0879 10.3333 15.0375 10.3333C12.9871 10.3333 11.325 10.9303 11.325 11.6667M18.75 11.6667V16.6667C18.75 17.403 17.0879 18 15.0375 18C12.9871 18 11.325 17.403 11.325 16.6667V11.6667M18.75 14.1667C18.75 14.903 17.0879 15.5 15.0375 15.5C12.9871 15.5 11.325 14.903 11.325 14.1667"
              stroke="#F7B27A"
              strokeWidth="1.05"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_5466_33167">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      price: '$2955',
      priceBg: '#F7B27A',
      detailsBg: '#FEF6EE',
      details: [
        'Build your own mining farm managed by ECOS',
        'Your ASICs are hosted at the powerful ECOS Data Center',
        'You get mined BTC daily',
      ],
      link: '/mining-store/buy-asics',
    },
    {
      title: 'Rent ASICs With Hosting',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5466_33237)">
            <rect
              x="0.43125"
              y="0.525"
              width="22.95"
              height="22.95"
              rx="4.275"
              stroke="#BCADF5"
              strokeWidth="1.05"
            />
            <path
              d="M7.7062 6.5H16.2937C16.3928 6.50017 16.4897 6.5298 16.572 6.58515C16.6542 6.64049 16.7182 6.71904 16.7557 6.81081C16.7932 6.90259 16.8026 7.00344 16.7826 7.10056C16.7627 7.19768 16.7143 7.28668 16.6437 7.35625L11.9999 12L7.3562 7.35625C7.28555 7.28668 7.23719 7.19768 7.21725 7.10056C7.19731 7.00344 7.20669 6.90259 7.2442 6.81081C7.28172 6.71904 7.34567 6.64049 7.42793 6.58515C7.51019 6.5298 7.60705 6.50017 7.7062 6.5V6.5Z"
              stroke="#BCADF5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.7062 17.5H16.2937C16.3928 17.4998 16.4897 17.4702 16.572 17.4149C16.6542 17.3595 16.7182 17.281 16.7557 17.1892C16.7932 17.0974 16.8026 16.9966 16.7826 16.8994C16.7627 16.8023 16.7143 16.7133 16.6437 16.6438L11.9999 12L7.3562 16.6438C7.28555 16.7133 7.23719 16.8023 7.21725 16.8994C7.19731 16.9966 7.20669 17.0974 7.2442 17.1892C7.28172 17.281 7.34567 17.3595 7.42793 17.4149C7.51019 17.4702 7.60705 17.4998 7.7062 17.5Z"
              stroke="#BCADF5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M8.5 8.5H15.5" stroke="#BCADF5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_5466_33237">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      price: '$1825',
      priceBg: '#BCADF5',
      detailsBg: '#F4F1FF',
      details: [
        'Rent ASIC Miner and host it in ECOS Data Center!',
        'Rent the latest ASIC models and start mining within 24 hours',
        'Benefit from nearly 100% uptime at ECOS Data Center',
      ],
      link: '/mining-store/rent-asics',
    },
    {
      title: 'Buy and Sell ASICs hosted at ECOS',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5466_33302)">
            <rect
              x="0.43125"
              y="0.525"
              width="22.95"
              height="22.95"
              rx="4.275"
              stroke="#83C69D"
              strokeWidth="1.05"
            />
            <path
              d="M16.3407 10.8665H12.9185C11.1217 10.8665 10.2232 10.8665 9.53694 11.2162C8.93325 11.5238 8.44244 12.0146 8.13484 12.6183C7.78516 13.3046 7.78516 14.203 7.78516 15.9999V17.2832M16.3407 10.8665L13.1324 7.6582M16.3407 10.8665L13.1324 14.0749"
              stroke="#83C69D"
              strokeWidth="1.16875"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_5466_33302">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      price: 'P2P deals',
      priceBg: '#83C69D',
      detailsBg: '#E1F3E6',
      details: [
        'Enter BTC mining at a lower cost',
        'Upgrade your existing mining farm',
        'Exit confidently from your investment',
      ],
      link: '/marketplace',
    },
  ];

  return (
    <div className="mining-products">
      <h2 className="mining-products__title-top">{getTranslation('btcMiningProducts', language)}</h2>
      <div className="mining-products__block holder">
        <div className="mining-products__cards">
          {products.map((product, index) => (
            <div key={index} className="mining-products__card">
              <div className="mining-products__title-buy-block">
                <a href={product.link} className="mining-products__arrow-link">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="mining-products__catd-img"
                    alt="arrow"
                  >
                    <circle cx="12" cy="12" r="11.5" stroke="#D0D5DD" />
                    <path
                      d="M15.9621 8.53786C15.9621 8.26172 15.7383 8.03786 15.4621 8.03786L10.9621 8.03786C10.686 8.03786 10.4621 8.26172 10.4621 8.53786C10.4621 8.814 10.686 9.03786 10.9621 9.03786L14.9621 9.03786L14.9621 13.0379C14.9621 13.314 15.186 13.5379 15.4621 13.5379C15.7383 13.5379 15.9621 13.314 15.9621 13.0379L15.9621 8.53786ZM8.89262 15.8145L15.8157 8.89141L15.1086 8.18431L8.18551 15.1074L8.89262 15.8145Z"
                      fill="#667085"
                    />
                  </svg>
                </a>
                <div className="mining-products__title-img">
                  {product.icon}
                  <h2 className="mining-products__title">{product.title}</h2>
                </div>
                <p
                  className="mining-products__button_buy"
                  style={{ backgroundColor: product.priceBg }}
                >
                  {getTranslation('from', language)} <span className="products__button_buy-falue">{product.price}</span>
                </p>
              </div>
              <div className="mining-products__details-block">
                <div
                  className="mining-products__details_buy"
                  style={{ backgroundColor: product.detailsBg }}
                >
                  <div className="mining-products__details-left_buy">
                    {product.details.map((detail, idx) => (
                      <div
                        key={idx}
                        className={`mining-products__details-buy ${
                          idx < product.details.length - 1 ? 'mining-products__details-buy_border' : ''
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M8 14.5C11.3137 14.5 14 11.8137 14 8.5C14 5.18629 11.3137 2.5 8 2.5C4.68629 2.5 2 5.18629 2 8.5C2 11.8137 4.68629 14.5 8 14.5Z"
                            stroke="#101828"
                            strokeMiterlimit="10"
                          />
                          <path
                            d="M10.25 7.75L8 10.25L5.75 7.75"
                            stroke="#101828"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <p className="mining-products__details-text">{detail}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="mining-products__market-block">
                <div className="mining-products__button-block">
                  <a href="/mining-store/promo">
                    <button className="transparent" type="button">
                      {getTranslation('getSpecialOffer', language)}
                    </button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MiningProducts;

